import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { Auth0ProviderWithRedirectCallback } from 'AppAuth0Provider'
import Spinning from 'components/Common/Spinner/Spinning'
import LogRocket from 'logrocket'
import { Suspense } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend as Backend } from 'react-dnd-html5-backend'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from 'reportWebVitals'
import store from 'store/configureStore'
import App from './App'
import { ErrorBoundary } from './components/Common/ErrorBoundary'
import './style/index.sass'
import 'polyfills'

const rootElement = document.getElementById('root')

if (
  process.env.REACT_APP_ENVIRONMENT === 'prd' ||
  process.env.REACT_APP_ENVIRONMENT === 'uat'
) {
  LogRocket.init('8jypme/rhodium24')
}

const app = (
  // <React.StrictMode>
  <Provider store={store}>
    <ErrorBoundary>
      <Suspense fallback={<Spinning />}>
        <BrowserRouter>
          <Auth0ProviderWithRedirectCallback
            domain="auth.quotenow.link"
            clientId="ZrEjq11NEqW4qgz4yhH52POwQWk0D2Zd"
            redirectUri={window.location.origin + '/auth/callback'}
            audience="https://api.rhodium24.io"
          >
            <DndProvider backend={Backend}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <App />
                <div id="root-portal"></div>
              </MuiPickersUtilsProvider>
            </DndProvider>
          </Auth0ProviderWithRedirectCallback>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  </Provider>
  // </React.StrictMode>
)

ReactDOM.render(app, rootElement, () => {
  rootElement.classList.remove('app-loader')
})

// try {
//   const po = new PerformanceObserver((list) => {
//     for (const entry of list.getEntries()) {
//       // Log the entry and all associated details.
//       console.log('long task logger', entry)
//     }
//   })

//   po.observe({ type: 'longtask', buffered: true })
// } catch (e) {
//   // Do nothing if the browser doesn't support this API.
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// serviceWorker.register({
//   // https://github.com/facebook/create-react-app/issues/5316
//   onUpdate: registration => {
//     alert('New version available! Update it now!')
//     window.location.reload()
//     if (registration && registration.waiting) {
//       registration.waiting.postMessage({ type: 'SKIP_WAITING' })
//     }
//   },
//   onSuccess: registration => {
//     while (true) {
//       setTimeout(() => {
//         console.log('calling registration.update')
//         registration.update()
//       }, 2000)
//     }
//   }
// })

// serviceWorker.unregister()
